import { Link } from "react-router-dom";
import type { Tool } from "../types";
import { useAuth } from "../context/AuthContext";

const AVAILABLE_TOOLS: (Tool & { path?: string })[] = [
  {
    id: "pos",
    name: "Point of Sale",
    description: "Process transactions, manage products, and track sales in real-time.",
    icon: "💳",
    enabled: true,
    requiredPlan: "free",
    path: "/dashboard/pos",
  },
  {
    id: "inventory",
    name: "Inventory Management",
    description: "Track stock levels, set reorder points, and manage suppliers.",
    icon: "📦",
    enabled: false,
    requiredPlan: "starter",
  },
  {
    id: "scheduling",
    name: "Staff Scheduling",
    description: "Create schedules, manage shifts, and track time & attendance.",
    icon: "📅",
    enabled: false,
    requiredPlan: "professional",
  },
  {
    id: "analytics",
    name: "Advanced Analytics",
    description: "Deep insights into sales trends, customer behavior, and forecasting.",
    icon: "📊",
    enabled: false,
    requiredPlan: "professional",
  },
  {
    id: "crm",
    name: "Customer Management",
    description: "Track customers, loyalty programs, and marketing campaigns.",
    icon: "👥",
    enabled: false,
    requiredPlan: "starter",
  },
  {
    id: "accounting",
    name: "Accounting & Finance",
    description: "Invoicing, expense tracking, and financial reporting.",
    icon: "💰",
    enabled: false,
    requiredPlan: "enterprise",
  },
];

const PLAN_ORDER = ["free", "starter", "professional", "enterprise"] as const;

function canAccess(currentPlan: string, requiredPlan: string): boolean {
  return PLAN_ORDER.indexOf(currentPlan as any) >= PLAN_ORDER.indexOf(requiredPlan as any);
}

export default function Tools() {
  const { organization } = useAuth();
  const currentPlan = organization?.plan || "free";

  return (
    <div>
      <h1>Tools</h1>
      <p className="page-subtitle">Manage and access your business tools.</p>

      <div className="tools-grid">
        {AVAILABLE_TOOLS.map((tool) => {
          const accessible = canAccess(currentPlan, tool.requiredPlan);
          return (
            <div key={tool.id} className="tool-card">
              <div className="tool-icon">{tool.icon}</div>
              <h3>{tool.name}</h3>
              <p>{tool.description}</p>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span className={`tool-badge ${accessible ? "available" : "locked"}`}>
                  {accessible ? "Available" : `Requires ${tool.requiredPlan}`}
                </span>
                {accessible && tool.path && (
                  <Link to={tool.path} style={{ fontSize: "0.85rem", fontWeight: 500 }}>
                    Launch →
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
